const FromArr = [{
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "产品型号/名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "平台：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "不显示0库存：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 35,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		hidden: false,
	}
]
export default FromArr;